var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "users_filter" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "users_filter",
            "no-close-on-backdrop": true,
            size: "xl",
            title: "Редагувати повідомлення",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function ({ ok, cancel }) {
                return [
                  _vm.show_action
                    ? _c("b-spinner", { attrs: { variant: "success" } })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "btn btn-lg waves-effect waves-themed mr-3",
                      attrs: { size: "xl", variant: "outline-primary" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.close_filter()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fal fa-check mr-1" }),
                      _vm._v("\n                Зберегти\n            "),
                    ]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "adjusted_list", attrs: { sm: "6" } },
                [
                  _vm.added.length > 0
                    ? _c(
                        "draggable",
                        _vm._b(
                          {
                            staticClass: "adj_move u_list",
                            model: {
                              value: _vm.added,
                              callback: function ($$v) {
                                _vm.added = $$v
                              },
                              expression: "added",
                            },
                          },
                          "draggable",
                          _vm.dragOptions("before"),
                          false
                        ),
                        _vm._l(_vm.added, function (item, idx) {
                          return _c("user_block", {
                            key: item.id,
                            attrs: {
                              show_vacation: true,
                              can_del: true,
                              del_triger: _vm.remove_invoice_from_doc,
                              user: item,
                            },
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.invoice.length > 0
                    ? _c("div", { staticClass: "user_list u_list" }, [
                        _c(
                          "div",
                          { staticClass: "isp_list" },
                          _vm._l(this.invoice, function (item) {
                            return _c("user_block", {
                              key: item.id,
                              attrs: { user: item },
                            })
                          }),
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.added_after.length > 0
                    ? _c(
                        "draggable",
                        _vm._b(
                          {
                            staticClass: "adj_move u_list",
                            model: {
                              value: _vm.added_after,
                              callback: function ($$v) {
                                _vm.added_after = $$v
                              },
                              expression: "added_after",
                            },
                          },
                          "draggable",
                          _vm.dragOptions("after"),
                          false
                        ),
                        _vm._l(_vm.added_after, function (item, idx) {
                          return _c("user_block", {
                            key: item.id,
                            attrs: {
                              show_vacation: true,
                              can_del: true,
                              del_triger: _vm.remove_invoice_from_doc_after,
                              user: item,
                            },
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { sm: "6" } }, [
                _c("div", { staticClass: "search_form" }, [
                  _c(
                    "div",
                    { staticClass: "search_filed" },
                    [
                      _c(
                        "b-input-group",
                        [
                          _c(
                            "b-input-group-text",
                            { attrs: { slot: "prepend" }, slot: "prepend" },
                            [_vm._v("по ПІБ, посада")]
                          ),
                          _vm._v(" "),
                          _c("b-form-input", {
                            model: {
                              value: _vm.search,
                              callback: function ($$v) {
                                _vm.search = $$v
                              },
                              expression: "search",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "users_list pt-3 ml-0 pl-0" }, [
                        _c(
                          "ul",
                          { staticClass: "user_list_to_insert ml-0 pl-0" },
                          _vm._l(_vm.searched, function (item) {
                            return _c(
                              "li",
                              { class: _vm.user_class(item, "before") },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "user_profile position-relative border mb-2",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex flex-row pt-2 pl-2 pb-2",
                                      },
                                      [
                                        _c("span", { staticClass: "status" }, [
                                          _c("span", {
                                            staticClass:
                                              "profile-image rounded-circle d-inline-block",
                                            style: {
                                              "background-image":
                                                "url(" + item.medium_img + ")",
                                              "background-size": "cover",
                                            },
                                          }),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "ml-3" }, [
                                          _c(
                                            "div",
                                            { staticClass: "user_attrib" },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "name d-block fw-700 text-dark",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    item.name
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "company small text-dark",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.user_company(item)
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "dolznost small text-dark",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    item.dolznost
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "vacation" },
                                                [
                                                  _c("vacation", {
                                                    attrs: {
                                                      id: parseInt(item.id),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "add_adjust" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "add_in_start cursor-pointer bg-warning-500 shadow text-white",
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.set_active(
                                                      item,
                                                      "before"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                    В початок\n                                                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.can_show_after
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "add_in_end cursor-pointer bg-warning-500 shadow text-white",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.set_active(
                                                          item,
                                                          "after"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                    В кінець\n                                                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }